<template>
    <div class="header">
        <header>
            <!--logo-->
            <div class="logo" @click="backHome" style="cursor: pointer;">
                <img src="../assets/search/logo.png" alt=""/>
            </div>
            <!--中间导航区域-->
            <ul  class="nav">
                <router-link :to="{name:operate.path}" v-slot="{ href, route, navigate, isActive, isExactActive }" v-for="(operate,index) in navTo" :key="index">
                    <li :class="[isActive && 'active', isExactActive && '']">
                        <a :href="href" @click="navigate">{{operate.name}}</a>
                    </li>
                </router-link>
                <!-- <li class="da-nav-item"><a href="http://contributor.123rf.com.cn/" target="_blank">供图者入口</a></li> -->
            </ul>
            <!--右边个人信息区域-->
            <div v-if="loggedIn" class="loging">
                <div class="kefu">
                    <img src="../assets/search/kf.png" alt="" @click="showTiShi()"/>
                </div>
                <div class="tishi">
                    <img src="../assets/search/ts.png" alt="" @click="showTongZhi()"/>
                    <span class="num" v-show="tongzhilength">{{tongzhilength}}</span>
                </div>
                <div class="userneme">
                    <span>欢迎，</span>
                    <span class="name">{{user_name}}</span>
                </div>
                <div class="user-down" @click.prevent="clickMenu_show_nav=!clickMenu_show_nav" ref="myPanel">
                    <img src="../assets/search/jt.png" class="" alt=""/>
                    <ul class="grzx" v-show="clickMenu_show_nav">
                        <li><a href="" @click.prevent="logOut()">退出登录</a></li>
                    </ul>
                </div>
            </div>
            <div v-else class="loging">
                <div class="userneme">
                    <a href="/login"><span>登录</span></a>
                </div>
            </div>
        </header>
        <!--弹窗框-->
        <!--遮罩层-->
        <div class="headerOverCurtain" v-show="headerOverCurtain"></div>
        <!--通知 超出可滑动-->
        <div class="tongzhi" v-show="tongzhi">
            <p class="hd">
                <span>通知</span>
                <img src="../assets/panel/close.png" class="close fr" alt="" @click="hideTongZhi()"/>
            </p>
            <div class="tongzhi-list">
                <ul>
                    <template v-if="tongzhiList.length">
                        <li v-for="(item,index) in tongzhiList" :key="index">
                            <p>日期：{{item.created_at}}</p>
                            <span>{{item.message_content}}</span>
                        </li>
                    </template>
                    <template v-else>
                        <li class="gray">暂无未读消息</li>
                    </template>
                </ul>
            </div>
        </div>
        <!--客服-->
        <div class="kefu-list" v-show="kefu">
            <p class="hd">
                <span>专属客服经理</span>
                <img src="../assets/panel/close.png" class="close fr" alt="" @click="hideTiShi()"/>
            </p>
            <div class="kefu-cont">
                <div class="kefu-img hd">
<!--                    <img src="../assets/comm/mr.png" alt="" class="fl"/>-->
                    <div class="name-tal">
                        <p class="kefu-name">{{customer.name}}</p>
                        <span class="kefu-tal">{{customer.mobile}}</span>
                    </div>
                </div>
                <ul class="ywq">
                    <li>
                        <img src="../assets/comm/kfyx.png" alt=""/>
                        <span class="mail">{{customer.email}}</span>
                    </li>
                    <li>
                        <img src="../assets/comm/kfqq.png" alt=""/>
                        <span class="mail">{{customer.qq}}</span>
                    </li>
                    <li>
                        <img src="../assets/comm/kfwx.png" alt=""/>
                        <span class="mail">{{customer.wechat}}</span>
                    </li>
                </ul>
                <div class="erweima ct">
                    <p>
                        <img :src="customer.qrcode" alt="qrcode"/>
                    </p>
                    <span>扫一扫加微信</span>
                </div>
                <div class="mingpian ct">
                    <a href="javascript:;" @click="downloadQrcode()">保存电子名片</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'header',
        data() {
            return {
                clickMenu_show_nav:false,
                navTo:[
                    {"name":"首页","path":'Index'},
                    {"name":"摄影图片","path":'Photography'},
                    {"name":"矢量图片","path":'Vector'},
 /*                   {"name":"优质视频","path":'Video'},*/
                    {"name":"专题","path":'Special_list'},
                    {"name":"用户中心","path":'UserCenter'},
                    {"name":"控制面板","path":'Dashboard'}
                ],
                user_name:'',
                headerOverCurtain:false,
                tongzhi:false,
                kefu:false,
                tongzhilength:0,
                tongzhiList:{},
                customer:{},
                loggedIn: this.getCookie('token')
            }
        },
        created() {
            this.userHide()
            this.getUserInfo()
            this.getTongzhiList()
        },
        mounted() {
        },
        methods: {
            backHome() {
                this.$router.push('/')
            },
            downloadQrcode(){
                window.location.href = this.customer.qrcode
            },
            getTongzhiList(){
                if (!this.getCookie('token')) return
                this.$post('/message/getlist').then(res=>{
                    if(res.code == 200){
                        this.tongzhilength = res.data.result.length
                        if(res.data.result.length>0){
                            this.tongzhiList = res.data.result
                        }
                    }
                })
            },
            showTongZhi(){
                this.headerOverCurtain=true
                this.tongzhi=true
                this.kefu=false

                this.$post('/message/updatestatus').then(res=>{
                    if(res.code == 200 && res.status=='success'){
                        this.tongzhilength = 0
                        this.getTongzhiList()
                    }
                })
            },
            showTiShi(){
                this.headerOverCurtain=true
                this.tongzhi=false
                this.kefu=true


                this.$post('/customer/getone').then(res=>{
                    if(res.code == 200 && res.status=='success'){
                        this.customer = res.data.result
                    }
                })
            },
            hideTongZhi(){
                this.headerOverCurtain=false
                this.tongzhi=false
                this.kefu=false
            },
            hideTiShi(){
                this.headerOverCurtain=false
                this.tongzhi=false
                this.kefu=false
            },
            getUserInfo(){
                if (!this.getCookie('token')) return
                if(!this.getCookie('user_name')){
                    this.$get('/me').then(res=>{
                        this.user_name = res.data.user.name
                        this.setCookie('user_name',res.data.user.name)
                        if(res.data.user.is_admin == 0 && res.data.user.type == 2){
                            this.setCookie('user_type',2)
                            this.navTo = [
                                {"name":"首页","path":'Index'},
                                {"name":"摄影图片","path":'Photography'},
                                {"name":"矢量图片","path":'Vector'},
                               /* {"name":"优质视频","path":'Video'},*/
                                {"name":"专题","path":'Special_list'},
                                {"name":"用户中心","path":'UserCenter'}
                            ]
                        }
                    })
                }else{
                    this.user_name = this.getCookie('user_name')
                    if(this.getCookie('user_type') == 2){
                        this.navTo = [
                            {"name":"首页","path":'Index'},
                            {"name":"摄影图片","path":'Photography'},
                            {"name":"矢量图片","path":'Vector'},
                            /*{"name":"优质视频","path":'Video'},*/
                            {"name":"专题","path":'Special_list'},
                            {"name":"用户中心","path":'UserCenter'}
                        ]
                    }
                }
            },
            clearCookie(name) {
                this.setCookie(name, "", -1);
            },
            logOut(){
                this.clearCookie("user_type");
                this.clearCookie("user_name");
                this.clearCookie("token");
                this.$router.push('/')
            },
            userHide() {
                document.addEventListener('click', (e) => {
                    if (this.$refs.myPanel && !this.$refs.myPanel.contains(e.target)) {
                        this.clickMenu_show_nav = false;
                    }
                })
            }
        }
    }
</script>


<style scoped>
    * {  padding: 0; margin: 0; box-sizing: border-box; font-family: "Source Han Sans CN",Arial,sans-serif;}
    a {text-decoration: none;color:#333;}
    .gray{color: #666}
    div, b, p, h1, h2, h3, h4, h5, h6,ul, li, dl, dd, header, footer {  margin: 0;  padding: 0;  list-style: none;  }
    em, i, b, strong {font-style: normal;font-weight: normal;}
    .ct{text-align: center;}
    .fl{float: left}
    .fr{float: right}
    .pr{position: relative}
    .pa{position: absolute}
    .hd{overflow: hidden;}
    img{vertical-align: top;}
    header{width: 100%;height: 70px;background: #fff;padding: 0 40px 0 30px;display: flex;justify-content: space-between;line-height: 70px;}
    header .logo{margin-top: 16px;}
    header .nav,header .loging{display: flex;justify-content: space-between;}
    .nav li{margin: 0 20px;text-align: center;}
    .nav li.active::after{content:"";display:block;background: #FF9F00;height: 2px;width:80%;margin: -15px auto 0; }
    .nav li.active{font-weight: 600;}
    .loging .kefu img,.loging .tishi img{margin: 17px 20px 0;cursor: pointer}
    .tishi{position: relative;}
    .tishi span.num{position: absolute;background: #E74C3A;border-radius:10px;color: #fff;min-width: 20px;height: 20px;font-size: 14px;text-align: center;line-height: 20px;display: inline-block;top:15px;right: 15px;padding: 0 4px;}
    .loging .user-down img{margin: 30px 10px 0}
    .user-down{cursor: pointer;position: relative;}
    .grzx{position: absolute;width: 90px;padding:10px;top:42px;right: 0px;background: #fff;z-index: 11111;text-align: center;}
    .grzx li{height: 30px;line-height: 30px;font-size: 14px;}
    .jiantou{ transform: rotate(180deg); -webkit-transform: rotate(180deg)}

    .swiper-slide a img{width:100%;height: 500px;}
    .banner >>> .swiper-pagination-bullet{width: 35px;height: 3px;background:#000;border-radius: 1px;opacity: .3;}
    .banner >>> .swiper-pagination-bullet-active{background:#FF9F00;opacity: 1}
    .serch{background: #fff;height: 60px;display: flex;justify-content: space-between;position: absolute;bottom: 60px;z-index: 11111111;left: 50%;margin-left: -360px;}
    .xiala{font-size: 14px;}
    .dropdown{width: 110px;text-align: center;line-height: 60px;cursor: pointer;}
    .inpt{width: 510px;padding-left: 5px;position: relative;}
    input{border: none;height: 60px;line-height: 60px;width: 100%;padding-left:40px;outline:none;font-size: 16px;}
    input::-webkit-input-placeholder {color:#666; font-size: 14px; }
    input:-moz-placeholder {color:#666; font-size: 14px; }
    input::-moz-placeholder {color:#666;font-size: 14px;  }
    input:-ms-input-placeholder {color:#666; font-size: 14px; }
    .icon-scrch{width: 110px;background: #FF9F00;text-align: center;}
    .icon-scrch img{margin-top: 16px;cursor: pointer;}

    .xiala img{margin-top: 24px;}
    .inpt img{margin-top: 18px;position: absolute;}
    .dropdown {position: relative;}
    .dropdown_menu {background: #fff;position: absolute;top: 60px;right: 0px;z-index: 1000;display: none;width: 110px;padding:10px 0;text-align: center;border-top: 1px solid #ddd;}
    .dropdown_menu dd{line-height: 34px!important;}
    .dropdown dl dd a {color: #333;line-height: 34px;font-size:14px;}
    .top-arrow1,.top-arrow2 {width:0;height:0;display:block;position:absolute;left:30px;top:-17px;z-index:5; /*����ie8-*/ border-top:8px transparent dashed;border-left:6px transparent dashed;border-right:6px transparent dashed;border-bottom:8px white solid;overflow:hidden;}
    .top-arrow1 {border-bottom:9px #ddd solid;}
    .top-arrow2 {top:-15px;border-bottom:9px #fff solid;}

    .img-all{padding: 50px 0;}
    .title{margin: 0 auto 50px;font-size: 26px;font-weight: 600;text-align: center;}
    .pubu{width: 1200px;margin: 0 auto;overflow: hidden;}
    .pubu li{border-radius: 10px;overflow: hidden;position: relative;float:left;margin:5px;cursor: pointer;}
    .pubu li:hover .zhezhao{display: none;}
    .pubu li .zhezhao{background: rgba(0,0,0,.2);position: absolute;top:0;right: 0;width: 100%;height: 100%;text-align: center;color: #fff;font-size: 22px;font-weight: 600;}
    .pubu li .zhezhao span{position: relative;top:50%;display: block;height: 30px;line-height: 30px;margin-top: -15px;}
    /*��������*/
    .hot-serch{padding: 50px 0;background: #F7F7F7;}
    .dbg{background: url("../assets/search/bg.png")no-repeat center;height: 41px;line-height: 41px;width: 167px;}
    .leixing{width: 1200px;margin: 0 auto;}
    .leixing ul{display: flex;justify-content: space-around;flex-wrap: wrap;}
    .leixing ul li{margin: 10px;}
    .leixing ul li a{display:inline-block;width: 130px;height: 40px;line-height: 40px;background: #fff;text-align: center;font-size: 14px;border-radius: 5px;}

    .headerOverCurtain{position:fixed;height:100%;width:100%;left:0px;top:0px;opacity:0.7;background:#0E0E0E;z-index: 111;}
    .tongzhi{height:480px;width:380px;}

    .tongzhi,.kefu-list{display:block;position:fixed;right:0;left:0;bottom:0;top:0;margin:auto;z-index:1111;background: #fff;padding: 25px 30px;font-size: 14px;}
    .tongzhi p.hd,.kefu-list p.hd{margin-bottom: 10px;}
    .tongzhi p.hd img.fr,.kefu-list p.hd img.fr{cursor: pointer;}
    .tongzhi p.hd span,.kefu-list p.hd span{font-size: 18px;font-weight: 600;}
    .tongzhi-list ul li{border-bottom: 1px solid #ccc;margin-top: 20px;text-align: left}
    .tongzhi-list ul li:last-child{border-bottom: none}
    .tongzhi-list ul li p{font-size: 12px;color: #999;}
    .tongzhi-list ul li span{font-size: 12px;display: inline-block;margin: 10px 0 15px;}
    .tongzhi-list ul{overflow-x: auto;height: 390px;}
    .tongzhi-list ul::-webkit-scrollbar {display: none;}

    .kefu-list{height: 540px;width: 380px;padding: 25px 50px}
    .kefu-cont{margin-top: 30px;}
    .kefu-img{margin-bottom: 30px;}
    .kefu-img img{width: 75px;height: 75px;border-radius: 50%;margin-right: 30px;}
    .kefu-name{margin: 12px 0 10px;font-size: 16px;font-weight: 600;}
    .kefu-tal{font-weight: 600;}
    .ywq li img{margin-right: 10px;}
    .ywq li{margin: 15px 0;text-align: left}
    .erweima p img{width: 120px;}
    .erweima span{font-size: 12px;color: #999;}
    .mingpian a{display: inline-block;background: #f7f7f7;height: 36px;line-height: 36px;padding: 0 20px;font-size: 14px;color: #666;border-radius: 20px;text-align: center;margin-top: 25px;}
    .userneme { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 160px; }
</style>
